export enum GlobalCheckoutRoutes {
  BASE = 'checkout',
  ORDER_SUMMARY = 'order-summary',
  GUEST_CHECKOUT = 'guest-checkout'
}
